'use server';

import { revalidatePath as nextRevalidatePath } from 'next/cache';
import { redirect as nextRedirect } from 'next/navigation';

/**
 * @description Action: wrapper for Next.js revalidatePath function. It revalidates the path and optionally redirects to it.
 * Can be called inside a client component.
 * @param path - The path to revalidate.
 * @param redirect - Redirect to the path after revalidation.
 */
export const revalidatePathAction = async (path: string, redirect?: boolean) => {
  nextRevalidatePath(path);
  if (redirect) nextRedirect(path);
};
